<template>
  <div>
    <SsgCollapse 
      v-for="(item, index) in treeData"
      :key="index"
      :title='item.name'
      :item="item"
    >
    <template v-slot:default="slotProps">
      <div v-if="item.views.length > 0">
        <PermissionContent
          v-for="(view, index) in item.views"
          :key="index"
          :view="view"
          :headCheckAll="slotProps.row.switched"
          @handCheck="handCheck"
          @switchChange="switchChange"
        >
         <div v-if="view.views.length > 0">
           <PerChild :treeData="view.views" :headCheckAll="view.switched"></PerChild>
         </div>
        </PermissionContent>
      </div>
    </template>
    </SsgCollapse>
  </div>
</template>

<script>
import SsgCollapse from "./collapse.vue";
import PermissionContent from "./permission-content.vue";
import PerChild from './per-child.vue'
export default {
  name: "PermissionList",
  components: {
    SsgCollapse,
    PermissionContent,
    PerChild
  },
  props: {
    treeData: Array
  },
  methods:{
    handCheck(o,n) {
      console.log(o,n,2222)
      o.funcsId = n;
    
    },
    switchChange(o,n){
      o.switched = n;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
</style>

